import { render } from "./GestionInformes.vue?vue&type=template&id=7e14bd96"
import script from "./GestionInformes.vue?vue&type=script&lang=js"
export * from "./GestionInformes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__